var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPbankicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_15518",
    x: 0,
    y: 0,
    width: 236,
    height: 236,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65598",
    "data-name": "Grupo 65598",
    transform: "translate(-1074 -1677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1074, 1677)",
    filter: "url(#Ret\\xE2ngulo_15518)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15518-2",
    "data-name": "Ret\\xE2ngulo 15518",
    width: 176,
    height: 176,
    rx: 4,
    transform: "translate(30 24)",
    fill: "#38d2d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65572",
    "data-name": "Grupo 65572",
    transform: "translate(4117.958 8093.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94833",
    "data-name": "Caminho 94833",
    d: "M505.012,50.891,479.89,44.037a26.206,26.206,0,0,0-14.224,0l-24.439,6.8a11.348,11.348,0,0,0,3.047,22.231l57.686.021a11.349,11.349,0,0,0,3.05-22.2Zm-3.05,15.993-57.686-.021a5.077,5.077,0,0,1-1.359-9.954l24.409-6.834a20.309,20.309,0,0,1,10.908,0L503.321,56.9a5.077,5.077,0,0,1-1.359,9.987Zm-22.9,43.382a3.322,3.322,0,0,1-3.116-3.119V82.129a3.117,3.117,0,1,1,6.233,0v25.018a3.116,3.116,0,0,1-3.117,3.119Zm-12.566,0a3.116,3.116,0,0,1-3.113-3.119V82.129a3.085,3.085,0,0,1,.136-1.288,3.114,3.114,0,0,1,5.925,0,3.088,3.088,0,0,1,.136,1.288v25.018a3.113,3.113,0,0,1-3.083,3.119Zm-24.9.166a3.113,3.113,0,0,1-3.08-3.119V82.129a3.083,3.083,0,0,1,.136-1.288,3.114,3.114,0,0,1,5.925,0,3.087,3.087,0,0,1,.136,1.288v25.184a3.116,3.116,0,0,1-3.117,3.119Zm12.6-.166a3.121,3.121,0,0,1-3.117-3.119V82.129a3.117,3.117,0,1,1,6.233,0v25.018a3.116,3.116,0,0,1-3.117,3.119Zm31.872,9.645a3.116,3.116,0,0,1-3.117,3.119l-46.791.023a3.119,3.119,0,0,1,0-6.238l46.891-.023a3.114,3.114,0,0,1,3.017,3.119ZM472.861,54.589a3.882,3.882,0,1,0,2.745,1.137A3.884,3.884,0,0,0,472.861,54.589Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94834",
    "data-name": "Caminho 94834",
    d: "M473.444,83.392a9.94,9.94,0,0,1-3.088,7.2,10.381,10.381,0,0,1-5.013,2.656v2.656a3.086,3.086,0,0,1-.136,1.289,3.139,3.139,0,0,1-.651,1.122,3.122,3.122,0,0,1-2.317,1.031,3.123,3.123,0,0,1-2.317-1.031,3.088,3.088,0,0,1-.647-1.122,3.144,3.144,0,0,1-.139-1.289V93.053a37.806,37.806,0,0,1-6.905-2.025,3.126,3.126,0,0,1-2.025-4.146,3.127,3.127,0,0,1,1.8-1.769,3.115,3.115,0,0,1,2.517.138,28.58,28.58,0,0,0,8.632,2.025,4.018,4.018,0,0,0,4.05-3.884,4.445,4.445,0,0,0-4.88-3.851,12.223,12.223,0,0,1-8.134-2.822,9.961,9.961,0,0,1,5.08-17.3V56.4a3.121,3.121,0,1,1,6.241,0v3.32a33.228,33.228,0,0,1,5.478,1.627,3.121,3.121,0,0,1-2.258,5.81A20.775,20.775,0,0,0,460.7,65.5a3.659,3.659,0,0,0-3.383,2.431,3.729,3.729,0,0,0-.2,1.453c0,2.324,2.092,3.851,5.212,3.851a10.653,10.653,0,0,1,11.122,10.159Z",
    transform: "translate(-3359.796 -6364.31)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPbankicon);
export default __webpack_public_path__ + "static/media/LPbankicon.fde962a04446a8cc50bc774f43650ffa.svg";
export { ForwardRef as ReactComponent };